module.exports = __webpack_public_path__ + "static/media/29EUNOG4.166eb6d2.jpg";